import React from 'react';
import PropTypes from "prop-types"

import {
  Content,
  Description,
  Highlight,
  Icon,
  MiniBanner,
  StyledButtonLink,
  StyledLink,
} from './styles';

export default function MiniBannerWithButton({ data, sectionId }) {
  if (!data || !sectionId) return null;

  const {
    bannerIcon,
    ctaLabel,
    ctaLink,
    ctaLinkText,
    description,
    highlight,
  } = data;

  const { altTag, url: iconUrl } = bannerIcon;
  const { url: buttonLink } = ctaLink;

  const imageAltTag = !altTag ? "prodigy pet icon" : altTag;
  const descriptionText = !description[0]?.text ? "" : description[0]?.text;
  const hightlightText = !highlight[0]?.text ? "" : highlight[0]?.text;

  return (
    <MiniBanner key={sectionId}>
      <Content>
        <Icon>
          <img src={iconUrl} alt={imageAltTag} /> {/* @TODO: convert to GatsyImage */}
        </Icon>
        <Description>
          {descriptionText} <Highlight>{hightlightText}</Highlight>
        </Description>
      </Content>
      <StyledLink
        to={buttonLink}
        ariaLabel={ctaLabel}
      >
        <StyledButtonLink
          className="solid-on-dark-bg"
        >
          {ctaLinkText}
        </StyledButtonLink>
      </StyledLink>
    </MiniBanner>
  )
}

MiniBannerWithButton.propTypes = {
  altTag: PropTypes.string,
  bannerIcon: PropTypes.shape(),
  ctaLabel: PropTypes.string,
  ctaLink: PropTypes.shape(),
  ctaLinkText: PropTypes.string,
  data: PropTypes.shape(),
  description: PropTypes.shape(),
  highlight: PropTypes.shape(),
  sectionId: PropTypes.string,
}

MiniBannerWithButton.defaultProps = {
  altTag: "",
  bannerIcon: {},
  ctaLabel: "",
  ctaLink: {},
  ctaLinkText: "",
  data: {},
  description: {},
  highlight: {},
  sectionId: "",
}
